import { useTranslation } from 'react-i18next'
import {
  usePromoteInboundSales,
  useTiersSectionAtom,
} from '@/features/priceCalculator/PurchaseForm/priceCalculatorAtoms'
import { type ProductOfferFragment } from '@/services/graphql/generated'
import { StoryblokComponent } from '@storyblok/react'
import { yStack } from 'ui/src/patterns/stack'
import { InboundSalesCard } from '../InboundSalesCard/InboundSalesCard'
import { SectionSubtitle } from '../SectionHeading'
import { SectionTitle } from '../SectionHeading'
import { ProductTierSelector } from './ProductTierSelector/ProductTierSelector'

export function TiersSection({
  tiers,
  selectedTier,
  onTierChange,
}: {
  tiers: Array<ProductOfferFragment>
  selectedTier: ProductOfferFragment
  onTierChange: (offerId: string) => void
}) {
  const { t } = useTranslation('purchase-form')
  const tiersSectionContent = useTiersSectionAtom()
  const promoteInboundSales = usePromoteInboundSales()

  return (
    <section className={yStack({ gap: promoteInboundSales ? 'md' : 'lg' })}>
      {tiersSectionContent.length > 0 ? (
        <div>
          {tiersSectionContent.map((blok) => (
            <StoryblokComponent key={blok._uid} blok={blok} nested={true} />
          ))}
        </div>
      ) : (
        <div>
          <SectionTitle>{t('OFFER_PRESENTER_TIERS_TITLE')}</SectionTitle>
          <SectionSubtitle>{t('OFFER_PRESENTER_TIERS_SUBTITLE')}</SectionSubtitle>
        </div>
      )}

      {promoteInboundSales && <InboundSalesCard />}

      <div className={yStack({ alignItems: 'stretch', gap: 'md' })}>
        <ProductTierSelector offers={tiers} selectedOffer={selectedTier} onValueChange={onTierChange} />
      </div>
    </section>
  )
}
